export const UPCOMING_ITEM_CARDS_COUNT = 20;
